import { Injectable } from "@angular/core";
import { AlertController, AlertOptions, Alert } from "ionic-angular";

@Injectable()
export class AlertComponent {
    constructor(public alertCtrl: AlertController){

    }

    /**
     * Crea un alert pasándole una serie de opciones
     * @param opts opciones del AlertController
     */
    public create(opts:AlertOptions):Alert{
        return this.alertCtrl.create(opts);
        
    }

    /**
     * Crea un alert personalizado con un boton de ACEPTAR
     * @param title titulo
     * @param message mensaje
     * @param handler evento al pulsar el boton
     */
    public openAlertAccept(title: string, subTitle: string, message: string, handler){
        this.alertCtrl.create({
            title: title, 
            subTitle: subTitle,
            message: message,
            buttons: [
                {
                    text: "Aceptar",
                    handler: handler
                }
            ]
        }).present();
    }

    

}


// WEBPACK FOOTER //
// ./src/components/alertComponent.ts